export class AwsFreeProtectionBilling {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "agreementId",
            "baseName": "agreementId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsFreeProtectionBilling.attributeTypeMap;
    }
    constructor() {
    }
}
